import { css } from '@emotion/css'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import { Autoplay, Keyboard, Mousewheel, Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { useCustomReducer } from '../../base/customHooks'
import { translate } from '../../base/localization'
import { IException } from '../../base/models'
import { ServiceRouter } from '../../base/proxy/serviceRouter'
import { SliderLoop } from '../../base/utils/dataHelper'
import Image from '../../components/IPImage'
import Stopwatch from '../../components/Stopwatch'
import { useAppSelector } from '../../redux/app/hooks'
import { selectedTheme } from '../../redux/slices/theme/themeSlice'
import { currentUser } from '../../redux/slices/user/userSlice'
import Translations from '../../translations'
import { IBannerCategory } from '../Admin/HomeAndSiteOperation/BannersCrud/models/requestModels'
import ProductIQuotaForm, {
  ProductIQuotaFormField,
  ProductIQuotaFormHandles,
} from '../ProductList/components/ProductIQuotaForm'
import { IBanner, IBannerTypeEnum, ICounterLocationEnum, ILocationEnum } from './commonModels/models'
import './css/HomePageSlider.scss'
import { GetBannerCategoriesApi } from './services/getBannerCategoriesApi'
import { GetBannersApi } from './services/getBannersApi'
import { OutboundClickRequestModel, PostOutboundClicksApi } from './services/postOutboundClickApi'
import { GetCreateKTCDemandApi, GetCreateMicrosoftDemandApi } from '../../redux/slices/basket/basketService'

enum SliderCategory {
  SpecialForToday = 1,
  Campaigns = 2,
  NewYear = 3,
  Privileges = 4,
}

interface HomepageSliderState {
  banners: IBanner[]
  oneAfterTheOtherStopwatchesOnTop: IBanner[]
  sliderStopwatchesOnTop: IBanner[]
  oneAfterTheOtherStopwatchesOnBottom: IBanner[]
  sliderStopwatchesOnBottom: IBanner[]
  topLeftBanners: IBanner[]
  bottomLeftBanners: IBanner[]
  rightBanners: IBanner[]
  specialForToday: boolean
  campaigns: boolean
  newYear: boolean
  privileges: boolean
  specialForMe?: IBanner
}

function HomePageSlider(props: any) {
  const t = translate(Translations)
  const getInitialState = (): HomepageSliderState => {
    return {
      banners: [],
      oneAfterTheOtherStopwatchesOnTop: [],
      sliderStopwatchesOnTop: [],
      oneAfterTheOtherStopwatchesOnBottom: [],
      sliderStopwatchesOnBottom: [],
      topLeftBanners: [],
      bottomLeftBanners: [],
      rightBanners: [],
      specialForToday: false,
      campaigns: false,
      newYear: false,
      privileges: false,
    }
  }

  const intialState = getInitialState()
  const [state, dispatch] = useCustomReducer<HomepageSliderState>(intialState)
  const theme = useAppSelector(selectedTheme)
  const [activeTab, setActiveTab] = useState(SliderCategory.SpecialForToday)
  const [bannerCategory, setBannerCategory] = useState<IBannerCategory[]>([])

  useEffect(() => {
    getBanners()
    getBannerCategory()
  }, [])

  const getBannerCategory = async () => {
    const getBannerCategoriesApi = new GetBannerCategoriesApi({})
    getBannerCategoriesApi.getBannerCategories().then(res => {
      if (res) {
        setBannerCategory(res)
      }
    })
  }

  const getBanners = () => {
    const api: GetBannersApi = new GetBannersApi({})
    api
      .getBanners()
      .then((res: IBanner[]) => {
        const sortedBanners = res.sort((a, b) => a.Order - b.Order)
        dispatch({ banners: sortedBanners })
      })
      .catch((err: IException) => {
        Swal.fire({
          icon: 'error',
          title: err.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
      })
  }

  useEffect(() => {
    dispatch({
      sliderStopwatchesOnTop: [],
      oneAfterTheOtherStopwatchesOnTop: [],
      topLeftBanners: [],
      bottomLeftBanners: [],
      rightBanners: [],
      sliderStopwatchesOnBottom: [],
      oneAfterTheOtherStopwatchesOnBottom: [],
      specialForToday: false,
      campaigns: false,
      newYear: false,
      privileges: false,
    })
    let filteredBanners = state.banners.filter(
      (bannerItem: IBanner) =>
        (bannerItem.CompanyList && bannerItem.CompanyList.indexOf(theme.id) > -1) ||
        (theme.id === 0 && bannerItem.IsHomepage)
    )
    if (filteredBanners && filteredBanners.length > 0) {
      const specialForMe: IBanner[] = filteredBanners.filter((banner: IBanner) => {
        return banner.Location === ILocationEnum.BanaOzel
      })
      dispatch({
        sliderStopwatchesOnTop: filteredBanners.filter((banner: IBanner) => {
          return (
            banner.Location === ILocationEnum.SayacAnaSayfaUst && banner.CounterLocation === ICounterLocationEnum.Slider
          )
        }),
        oneAfterTheOtherStopwatchesOnTop: filteredBanners.filter((banner: IBanner) => {
          return (
            banner.Location === ILocationEnum.SayacAnaSayfaUst &&
            banner.CounterLocation === ICounterLocationEnum.AltAlta
          )
        }),
        topLeftBanners: filteredBanners.filter((banner: IBanner) => {
          return banner.Location === ILocationEnum.AnaSayfaSolUst
        }),
        bottomLeftBanners: filteredBanners.filter((banner: IBanner) => {
          return banner.Location === ILocationEnum.AnaSayfaSolAlt
        }),
        rightBanners: filteredBanners.filter((banner: IBanner) => {
          return banner.Location === ILocationEnum.AnaSayfaSag
        }),
        sliderStopwatchesOnBottom: filteredBanners.filter((banner: IBanner) => {
          return (
            banner.Location === ILocationEnum.SayacAnaSayfaAlt && banner.CounterLocation === ICounterLocationEnum.Slider
          )
        }),
        oneAfterTheOtherStopwatchesOnBottom: filteredBanners.filter((banner: IBanner) => {
          return (
            banner.Location === ILocationEnum.SayacAnaSayfaAlt &&
            banner.CounterLocation === ICounterLocationEnum.AltAlta
          )
        }),
        specialForMe: specialForMe[0],
      })
    }
  }, [state.banners, theme.id])

  useEffect(() => {
    if (state.rightBanners && state.rightBanners.length > 0) {
      state.rightBanners.map((right: any) => {
        if (right.Category === 1) return dispatch({ specialForToday: true })
        if (right.Category === 2) return dispatch({ campaigns: true })
        if (right.Category === 3) return dispatch({ newYear: true })
        if (right.Category === 4) return dispatch({ privileges: true })
      })
    }
  }, [state.rightBanners])

  // Sekmeler admin'in belirlediği kategori sırasıyla (Order) dizilir; banner'lar kategoriye Id ile bağlıdır.
  // Order alanı olmayan eski kayıtta Id sırası kullanılır.
  const categoryRank = (category: SliderCategory) => {
    const item = bannerCategory.find(ban => ban.Id === category)
    return item?.Order ?? category
  }

  const sliderTabs = [
    { category: SliderCategory.SpecialForToday, visible: state.specialForToday, target: 'specialfor' },
    { category: SliderCategory.Campaigns, visible: state.campaigns, target: 'campaigns' },
    { category: SliderCategory.NewYear, visible: state.newYear, target: 'newyear' },
    { category: SliderCategory.Privileges, visible: state.privileges, target: 'privileges' },
  ]
    .filter(tab => tab.visible)
    .sort((a, b) => categoryRank(a.category) - categoryRank(b.category) || a.category - b.category)

  const firstTab = sliderTabs.length > 0 ? sliderTabs[0].category : undefined

  useEffect(() => {
    if (firstTab !== undefined) setActiveTab(firstTab)
  }, [firstTab])

  const fullWidthLinks = css`
    a {
      width: 100%;
    }
  `

  const navLinkActive = css`
    color: ${theme.colors.backgroundColor}!important;
    border-bottom: 3px solid ${theme.colors.backgroundColor}!important;
  `

  const iQuotaFormRef = React.useRef<ProductIQuotaFormHandles>(null)
  const user = useAppSelector(currentUser)

  const forwardIQuotePage = () => {
    /**
      Mandatory Field uEmail was not included in the request body
      Mandatory Field uName was not included in the request body
      Mandatory Field cAccountNum was not included in the request body
      Mandatory Field cName was not included in the request body
      Mandatory Field cPCode was not included in the request body
      */
    iQuotaFormRef.current?.setFormInputValueByName(ProductIQuotaFormField.uEmail, 'vvvv@bbbb.com')
    iQuotaFormRef.current?.setFormInputValueByName(ProductIQuotaFormField.uName, 'bvcb')
    iQuotaFormRef.current?.setFormInputValueByName(ProductIQuotaFormField.cAccountNum, '054455411100000')
    iQuotaFormRef.current?.setFormInputValueByName(ProductIQuotaFormField.cName, 'com')
    iQuotaFormRef.current?.setFormInputValueByName(ProductIQuotaFormField.cPCode, '34406')
    iQuotaFormRef.current?.setFormInputValueByName(
      ProductIQuotaFormField.ref,
      `${window.location.origin}/api/iquote-service-response/${user.SessionId}`
    )
    iQuotaFormRef.current?.setFormInputValueByName(
      ProductIQuotaFormField.BasketURL,
      `${window.location.origin}/api/iquote-service-response/${user.SessionId}`
    )
    iQuotaFormRef.current?.submitForm()
  }

  const [clickLocked, setClickLocked] = useState(false)

  // Helper function to check if a URL should trigger outbound tracking
  // Tracks external links OR internal content links (images, videos, documents, etc.)
  const isOutboundLink = (url: string): boolean => {
    if (!url) return false
    const isInternalLink = url.includes('https://www.indexgruppazar.com')
    const isContentLink = url.includes('/content/')
    // Track if it's an external link OR if it's an internal content link
    return !isInternalLink || isContentLink
  }

  const handleOutBoundClicks = async (bannerId: number, bannerName: string) => {
    if (clickLocked) return
    setClickLocked(true)

    const req: OutboundClickRequestModel = {
      BannerId: bannerId,
      BannerName: bannerName,
    }
    try {
      const postOutboundlicks: PostOutboundClicksApi = new PostOutboundClicksApi({})
      await postOutboundlicks.postOutboundClicks(req)
    } catch (error) {
      console.error('Error posting company homepage clicks:', error)
    } finally {
      setClickLocked(false)
    }
  }

  const handleSendMail = async (type: string) => {
    if (type === 'Microsoft') {
      const api = new GetCreateMicrosoftDemandApi({})

      const confirmation = await Swal.fire({
        title: 'Microsoft ürünleri için Satış Uzmanına talep iletmek istediğinize emin misiniz?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#ec4c4c',
        cancelButtonText: 'Vazgeç',
        confirmButtonText: 'Evet',
      })

      if (confirmation.isConfirmed) {
        try {
          // props.showLoading();
          const result = await api.getCreateMicrosoftDemand()
          if (result) {
            // props.hideLoading();
            await Swal.fire({
              html: `<h5>${result}</h5>`,
              confirmButtonText: t('components.AddToBasket.continueToShopping'),
              confirmButtonColor: '#ec4c4c',
            })
          }
        } catch (err: any) {
          // props.hideLoading();
          await Swal.fire({
            icon: 'error',
            title: err.description || 'Bir hata oluştu',
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        }
      } else {
        Swal.close()
      }
    }
    else if (type === 'KTC') {
      const api = new GetCreateKTCDemandApi({})

      const confirmation = await Swal.fire({
        title: 'KTC ürünleri için Satış Uzmanına talep iletmek istediğinize emin misiniz?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#ec4c4c',
        cancelButtonText: 'Vazgeç',
        confirmButtonText: 'Evet',
      })

      if (confirmation.isConfirmed) {
        try {
          // props.showLoading();
          const result = await api.getCreateKTCDemand()
          if (result) {
            // props.hideLoading();
            await Swal.fire({
              html: `<h5>${result}</h5>`,
              confirmButtonText: t('components.AddToBasket.continueToShopping'),
              confirmButtonColor: '#ec4c4c',
            })
          }
        } catch (err: any) {
          // props.hideLoading();
          await Swal.fire({
            icon: 'error',
            title: err.description || 'Bir hata oluştu',
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        }
      } else {
        Swal.close()
      }
    }

  }

  const stopwatchCompanyLogoMap: Record<number, { src: string; name: string }> = {
    1: { src: '/images/index-logo.png', name: 'Index' },
    2: { src: '/images/netex_logo.png', name: 'Netex' },
    3: { src: '/images/despec_logo.png', name: 'Despec' },
    4: { src: '/images/datagate_logo.png', name: 'Datagate' },
  }
  const stopwatchLogoDesign: 'spot' | 'full' = 'spot'

  const normalizeCompanyList = (companyList: unknown): number[] => {
    if (!companyList) return []

    if (Array.isArray(companyList)) {
      return companyList
        .map(companyId => Number(companyId))
        .filter((companyId: number) => !Number.isNaN(companyId))
    }

    if (typeof companyList === 'string') {
      return companyList
        .split(',')
        .map(companyId => Number(companyId.trim()))
        .filter((companyId: number) => !Number.isNaN(companyId))
    }

    return []
  }

  const getStopwatchCompanyLogo = (companyList: unknown) => {
    const uniqueCompanyIds = Array.from(new Set(normalizeCompanyList(companyList)))
    const nonHomepageCompanyIds = uniqueCompanyIds.filter((companyId: number) => companyId !== 0)
    if (nonHomepageCompanyIds.length !== 1) return null

    return stopwatchCompanyLogoMap[nonHomepageCompanyIds[0]] || null
  }

  const renderStopwatchWithCompanyLogo = (stopWatch: IBanner) => {
    const companyLogo = getStopwatchCompanyLogo(stopWatch.CompanyList)

    return (
      <div className='stopwatch-banner-wrapper'>
        <Stopwatch
          startDate={new Date(stopWatch.StartDate)}
          endDate={new Date(stopWatch.EndDate)}
          imageUrl={stopWatch.ImageUrl}
          isInSlider={true}
          height={props.height}
          text={stopWatch.Description}
        />
        {companyLogo && (
          <div className={`stopwatch-company-logo stopwatch-company-logo--${stopwatchLogoDesign}`}>
            <img src={companyLogo.src} alt={`${companyLogo.name} logo`} />
          </div>
        )}
      </div>
    )
  }

  return (
    <section className={`home-page-slider ${fullWidthLinks}`}>
      <div className='container'>
        {state.sliderStopwatchesOnTop && state.sliderStopwatchesOnTop.length > 0 && (
          <div className='row mb-4'>
            <div className='col-12'>
              <Swiper
                navigation={true}
                keyboard={true}
                loop={state.sliderStopwatchesOnTop.length === 1 ? false : true}
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
                }}
                pagination={{ clickable: true }}
                observer={true}
                observeParents={true}
                modules={[Navigation, Mousewheel, Keyboard, Pagination, Autoplay]}
                className='mySwiper'
              >
                {state.sliderStopwatchesOnTop.map((stopWatch: IBanner, index: number) => {
                  return (
                    <SwiperSlide key={index}>
                      {stopWatch.BannerType !== IBannerTypeEnum.LinkYok ? (
                        stopWatch.ProductAddress ? (
                          <a
                            href={stopWatch.ProductAddress}
                            target={stopWatch.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
                            rel='noreferrer'
                          >
                            {renderStopwatchWithCompanyLogo(stopWatch)}
                          </a>
                        ) : (
                          <Link
                            to={`/products?bannerId=${stopWatch.Id}`}
                            target={stopWatch.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
                          >
                            {renderStopwatchWithCompanyLogo(stopWatch)}
                          </Link>
                        )
                      ) : (
                        renderStopwatchWithCompanyLogo(stopWatch)
                      )}
                    </SwiperSlide>
                  )
                })}
              </Swiper>
            </div>
          </div>
        )}
        {state.oneAfterTheOtherStopwatchesOnTop &&
          state.oneAfterTheOtherStopwatchesOnTop.map((stopWatch: IBanner) => {
            return (
              <div className='row mb-4' key={stopWatch.Id}>
                <div className='col-12'>
                  <SwiperSlide key={stopWatch.Id}>
                    {stopWatch.BannerType !== IBannerTypeEnum.LinkYok ? (
                      stopWatch.ProductAddress ? (
                        <a
                          href={stopWatch.ProductAddress}
                          target={stopWatch.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
                          rel='noreferrer'
                          onClick={() => {
                            if (isOutboundLink(stopWatch.ProductAddress))
                              handleOutBoundClicks(stopWatch.Id, stopWatch.Title)
                          }}
                        >
                          {renderStopwatchWithCompanyLogo(stopWatch)}
                        </a>
                      ) : (
                        <Link
                          to={`/products?bannerId=${stopWatch.Id}`}
                          target={stopWatch.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
                        >
                          {renderStopwatchWithCompanyLogo(stopWatch)}
                        </Link>
                      )
                    ) : (
                      renderStopwatchWithCompanyLogo(stopWatch)
                    )}
                  </SwiperSlide>
                </div>
              </div>
            )
          })}
        {/* <div className={bannerStyles}>
          <div className='banner__small'>
            <div className='banner__swiper'></div>
            <div className='banner__swiper'></div>
          </div>
          <div className='banner__main'></div>
        </div> */}
        <div className='banner'>
          {state.topLeftBanners.length > 0 && state.bottomLeftBanners.length > 0 && (
            <div className='banner__small'>
              {state.topLeftBanners.length > 0 && (
                <div className='banner__swiper'>
                  <Swiper
                    navigation={true}
                    pagination={{ clickable: true }}
                    loop={state.bottomLeftBanners.length === 1 ? false : true}
                    mousewheel={true}
                    keyboard={true}
                    autoplay={{
                      delay: 15000,
                      disableOnInteraction: false,
                    }}
                    observer={true}
                    observeParents={true}
                    modules={[Navigation, Pagination, Autoplay, Mousewheel, Keyboard]}
                    className='mySwiper mb-2'
                  >
                    {state.topLeftBanners
                      .filter(item => {
                        {
                          return item.Location == ILocationEnum.AnaSayfaSolUst
                        }
                      })
                      .map((banner, index) => {
                        return (
                          <SwiperSlide key={index}>
                            {banner.BannerType === IBannerTypeEnum.YoutubeVideo ? (
                              banner.VideoId && (
                                <iframe
                                  width='100%'
                                  style={{ height: '400px' }}
                                  src={'https://www.youtube.com/embed/' + banner.VideoId}
                                  title='YouTube video player'
                                  allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                                ></iframe>
                              )
                            ) : banner.BannerType === IBannerTypeEnum.VimeoVideo ? (
                              banner.VideoId && (
                                <iframe
                                  src={
                                    'https://player.vimeo.com/video/' + banner.VideoId + '?h=ff2b296e05&color=ffffff'
                                  }
                                  width='640'
                                  height='360'
                                  allow='autoplay; fullscreen; picture-in-picture'
                                ></iframe>
                              )
                            ) : banner.BannerType !== IBannerTypeEnum.LinkYok ? (
                              banner.Image && banner.Image.toLocaleLowerCase('tr-TR').indexOf('.mp4') > -1 ? (
                                <video
                                  width='100%'
                                  preload='auto'
                                  autoPlay
                                  muted
                                  controls
                                  style={{ height: '100%', padding: '0px 0 0 0' }}
                                >
                                  <source src={banner.ImageUrl} type='video/mp4'></source>
                                  Sorry, your browser doesn't support videos.
                                </video>
                              ) : // ) : banner.ProductAddress ? (
                                //   <a
                                //     href={banner.ProductAddress}
                                //     target={banner.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
                                //     rel='noreferrer'
                                //   >
                                //     {
                                //       <Image
                                //         className='banner'
                                //         style={{ height: '100%', padding: '0px 0 0 0' }}
                                //         src={banner.ImageUrl}
                                //         alt={banner.Title}
                                //       />
                                //     }
                                //   </a>
                                // )

                                /* Anasayfa iQuote yönlendirmesi */
                                banner.ProductAddress.includes('https://iquote.hpe.com') ? (
                                  <img
                                    loading='lazy'
                                    className='banner'
                                    style={{ height: '100%', padding: '0px 0 0 0', cursor: 'pointer' }}
                                    src={banner.ImageUrl}
                                    alt={banner.Title}
                                    onClick={() => {
                                      forwardIQuotePage()
                                      handleOutBoundClicks(banner.Id, banner.Title)
                                    }}
                                  />
                                ) : banner.ProductAddress ? (
                                  <a
                                    className={isOutboundLink(banner.ProductAddress) ? 'outbound_link' : ''}
                                    href={banner.ProductAddress}
                                    target={banner.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
                                    rel='noreferrer'
                                    onClick={() => {
                                      if (isOutboundLink(banner.ProductAddress))
                                        handleOutBoundClicks(banner.Id, banner.Title)
                                    }}
                                  >
                                    {
                                      <Image
                                        className='banner'
                                        style={{ height: '100%', padding: '0px 0 0 0' }}
                                        src={banner.ImageUrl}
                                        alt={banner.Title}
                                      />
                                    }
                                  </a>
                                ) : (
                                  <Link
                                    to={`/products?bannerId=${banner.Id}`}
                                    target={banner.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
                                  >
                                    <Image
                                      className='banner'
                                      style={{ height: '100%', padding: '0px 0 0 0' }}
                                      src={banner.ImageUrl}
                                      alt={banner.Title}
                                    />
                                  </Link>
                                )
                            ) : (
                              <Image
                                className='banner'
                                style={{ height: '100%', padding: '0px 0 0 0' }}
                                src={banner.ImageUrl}
                                alt={banner.Title}
                              />
                            )}
                            {banner.Id === 2687 && (
                              <button className='custom-mail-button' style={{ backgroundColor: '#ff00cc' }} onClick={() => { handleSendMail('KTC') }}>
                                <i className='fa fa-envelope' aria-hidden='true'>
                                  <span> Size özel fiyat almak için tıklayınız!</span>
                                </i>
                              </button>
                            )}
                          </SwiperSlide>
                        )
                      })}
                  </Swiper>
                </div>
              )}
              {state.bottomLeftBanners.length > 0 && (
                <div className='banner__swiper'>
                  <Swiper
                    navigation={true}
                    loop={state.bottomLeftBanners.length === 1 ? false : true}
                    autoplay={{
                      delay: 15000,
                      disableOnInteraction: false,
                    }}
                    observer={true}
                    observeParents={true}
                    mousewheel={true}
                    keyboard={true}
                    pagination={{ clickable: true }}
                    modules={[Navigation, Pagination, Autoplay, Mousewheel, Keyboard]}
                    className='mySwiper'
                  >
                    {state.bottomLeftBanners
                      .filter(item => {
                        {
                          return item
                        }
                      })
                      .map((banner, index) => {
                        return (
                          <SwiperSlide key={index}>
                            {banner.BannerType === IBannerTypeEnum.YoutubeVideo ? (
                              banner.VideoId && (
                                <iframe
                                  width='100%'
                                  style={{ height: '400px' }}
                                  src={'https://www.youtube.com/embed/' + banner.VideoId}
                                  title='YouTube video player'
                                  allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                                ></iframe>
                              )
                            ) : banner.BannerType === IBannerTypeEnum.VimeoVideo ? (
                              banner.VideoId && (
                                <iframe
                                  src={
                                    'https://player.vimeo.com/video/' + banner.VideoId + '?h=ff2b296e05&color=ffffff'
                                  }
                                  width='640'
                                  height='360'
                                  allow='autoplay; fullscreen; picture-in-picture'
                                ></iframe>
                              )
                            ) : banner.BannerType !== IBannerTypeEnum.LinkYok ? (
                              banner.Image && banner.Image.toLocaleLowerCase('tr-TR').indexOf('.mp4') > -1 ? (
                                <video
                                  width='100%'
                                  preload='auto'
                                  autoPlay
                                  muted
                                  controls
                                  style={{ height: '100%', padding: '0px 0 0 0' }}
                                >
                                  <source src={banner.ImageUrl} type='video/mp4'></source>
                                  Sorry, your browser doesn't support videos.
                                </video>
                              ) : banner.ProductAddress ? (
                                <a
                                  className={isOutboundLink(banner.ProductAddress) ? 'outbound_link' : ''}
                                  href={banner.ProductAddress}
                                  target={banner.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
                                  rel='noreferrer'
                                  onClick={() => {
                                    if (isOutboundLink(banner.ProductAddress))
                                      handleOutBoundClicks(banner.Id, banner.Title)
                                  }}
                                >
                                  {
                                    <Image
                                      className='banner'
                                      style={{ height: '100%', padding: '0px 0 0 0' }}
                                      src={banner.ImageUrl}
                                      alt={banner.Title}
                                    />
                                  }
                                </a>
                              ) : (
                                <Link
                                  to={`/products?bannerId=${banner.Id}`}
                                  target={banner.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
                                >
                                  {
                                    <Image
                                      className='banner'
                                      style={{ height: '100%', padding: '0px 0 0 0' }}
                                      src={banner.ImageUrl}
                                      alt={banner.Title}
                                    />
                                  }
                                </Link>
                              )
                            ) : (
                              <Image
                                className='banner'
                                style={{ height: '100%', padding: '0px 0 0 0' }}
                                src={banner.ImageUrl}
                                alt={banner.Title}
                              />
                            )}
                          </SwiperSlide>
                        )
                      })}
                  </Swiper>
                  <button className='custom-mail-button' onClick={() => { handleSendMail('Microsoft') }}>
                    <i className='fa fa-envelope' aria-hidden='true'>
                      <span> Size özel fiyat almak için tıklayınız!</span>
                    </i>
                  </button>
                </div>
              )}
            </div>
          )}
          {state.rightBanners && state.rightBanners.length > 0 && (
            <div
              className='banner__main'
              style={ServiceRouter.getUrl() === 'https://dev-b2b.vbt.com.tr:1443' ? {} : { MozPaddingEnd: '500px' }}
            >
              <div className='tabs' style={{ height: '100%' }}>
                <ul className='nav nav-tabs' id='myTab' role='tablist' style={{ height: 36 }}>
                  {sliderTabs.map(tab => (
                    <li className='nav-item' key={tab.category}>
                      <a
                        className={`nav-link ${activeTab === tab.category ? navLinkActive : ''} ${css`
                          ascent-override: 0%;
                        `}`}
                        id={`${tab.category}`}
                        data-toggle='tab'
                        href={`#${tab.target}`}
                        role='tab'
                        aria-controls={tab.target}
                        aria-selected={activeTab === tab.category}
                        style={{ height: '36px' }}
                        onClick={() => setActiveTab(tab.category)}
                      >
                        {bannerCategory.find(ban => ban.Id === tab.category)?.Description}
                      </a>
                    </li>
                  ))}
                </ul>
                <div style={{ height: 'calc(100% - 36px)' }}>
                  {activeTab === SliderCategory.SpecialForToday && (
                    <div
                      className='tab-pane fade active show'
                      id={SliderCategory.SpecialForToday.toString()}
                      role='tabpanel'
                      aria-labelledby='specialfor'
                      style={{ height: '100%' }}
                    >
                      <Swiper
                        navigation={true}
                        keyboard={true}
                        loop={SliderLoop(state.rightBanners, ILocationEnum.AnaSayfaSag, Number(activeTab))}
                        autoplay={{
                          delay: 15000,
                          disableOnInteraction: false,
                        }}
                        pagination={{ clickable: true }}
                        observer={true}
                        observeParents={true}
                        modules={[Navigation, Mousewheel, Keyboard, Pagination, Autoplay]}
                        className='mySwiper'
                      >
                        {state.rightBanners &&
                          state.rightBanners
                            .filter((bannerItem: IBanner) => {
                              return (
                                bannerItem.Location === ILocationEnum.AnaSayfaSag &&
                                bannerItem.Category &&
                                bannerItem.Category === Number(activeTab)
                              )
                            })
                            .map((banner: IBanner, index: number) => {
                              return (
                                <SwiperSlide key={index}>
                                  {banner.BannerType === IBannerTypeEnum.YoutubeVideo ? (
                                    banner.VideoId && (
                                      <iframe
                                        width='100%'
                                        style={{ height: '400px' }}
                                        src={'https://www.youtube.com/embed/' + banner.VideoId}
                                        title='YouTube video player'
                                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                                      ></iframe>
                                    )
                                  ) : banner.BannerType === IBannerTypeEnum.VimeoVideo ? (
                                    banner.VideoId && (
                                      <iframe
                                        src={
                                          'https://player.vimeo.com/video/' +
                                          banner.VideoId +
                                          '?h=ff2b296e05&color=ffffff'
                                        }
                                        width='640'
                                        height='360'
                                        allow='autoplay; fullscreen; picture-in-picture'
                                      ></iframe>
                                    )
                                  ) : banner.BannerType !== IBannerTypeEnum.LinkYok ? (
                                    banner.Image && banner.Image.toLocaleLowerCase('tr-TR').indexOf('.mp4') > -1 ? (
                                      <video
                                        width='100%'
                                        preload='auto'
                                        autoPlay
                                        muted
                                        controls
                                        style={{ height: '100%', padding: '0px 0 0 0' }}
                                      >
                                        <source src={banner.ImageUrl} type='video/mp4'></source>
                                        Sorry, your browser doesn't support videos.
                                      </video>
                                    ) : banner.ProductAddress ? (
                                      <a
                                        className={isOutboundLink(banner.ProductAddress) ? 'outbound_link' : ''}
                                        href={banner.ProductAddress}
                                        target={banner.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
                                        rel='noreferrer'
                                        onClick={() => {
                                          if (isOutboundLink(banner.ProductAddress))
                                            handleOutBoundClicks(banner.Id, banner.Title)
                                        }}
                                      >
                                        {
                                          <Image
                                            className='banner'
                                            style={{
                                              height: '100%',
                                              padding: '0px 0 0 0',
                                              objectFit: 'contain',
                                              objectPosition: 'bottom',
                                              backgroundColor: '#f5f5f5',
                                            }}
                                            src={banner.ImageUrl}
                                            alt={banner.Title}
                                          />
                                        }
                                      </a>
                                    ) : (
                                      <Link
                                        to={`/products?bannerId=${banner.Id}`}
                                        target={banner.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
                                      >
                                        {
                                          <Image
                                            className='banner'
                                            style={{
                                              height: '100%',
                                              padding: '0px 0 0 0',
                                              objectFit: 'contain',
                                              objectPosition: 'bottom',
                                              backgroundColor: '#f5f5f5',
                                            }}
                                            src={banner.ImageUrl}
                                            alt={banner.Title}
                                          />
                                        }
                                      </Link>
                                    )
                                  ) : (
                                    <Image
                                      className='banner'
                                      style={{
                                        height: '100%',
                                        padding: '0px 0 0 0',
                                        objectFit: 'contain',
                                        objectPosition: 'bottom',
                                        backgroundColor: '#f5f5f5',
                                      }}
                                      src={banner.ImageUrl}
                                      alt={banner.Title}
                                    />
                                  )}
                                </SwiperSlide>
                              )
                            })}
                      </Swiper>
                    </div>
                  )}
                  {activeTab === SliderCategory.Campaigns && (
                    <div
                      className='tab-pane fade active show'
                      id={SliderCategory.Campaigns.toString()}
                      role='tabpanel'
                      aria-labelledby='campaigns-tab'
                      style={{ height: '100%' }}
                    >
                      <Swiper
                        navigation={true}
                        keyboard={true}
                        loop={SliderLoop(state.rightBanners, ILocationEnum.AnaSayfaSag, Number(activeTab))}
                        autoplay={{
                          delay: 15000,
                          disableOnInteraction: false,
                        }}
                        pagination={{ clickable: true }}
                        observer={true}
                        observeParents={true}
                        modules={[Navigation, Mousewheel, Keyboard, Pagination, Autoplay]}
                        className='mySwiper'
                      >
                        {state.rightBanners &&
                          state.rightBanners
                            .filter((bannerItem: IBanner) => {
                              return (
                                bannerItem.Location === ILocationEnum.AnaSayfaSag &&
                                bannerItem.Category &&
                                bannerItem.Category === Number(activeTab)
                              )
                            })
                            .map((banner: IBanner, index: number) => {
                              return (
                                <SwiperSlide key={index}>
                                  {banner.BannerType === IBannerTypeEnum.YoutubeVideo ? (
                                    banner.VideoId && (
                                      <iframe
                                        width='100%'
                                        style={{ height: '400px' }}
                                        src={'https://www.youtube.com/embed/' + banner.VideoId}
                                        title='YouTube video player'
                                        frameBorder='0'
                                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                                        allowFullScreen
                                      ></iframe>
                                    )
                                  ) : banner.BannerType === IBannerTypeEnum.VimeoVideo ? (
                                    banner.VideoId && (
                                      <iframe
                                        src={
                                          'https://player.vimeo.com/video/' +
                                          banner.VideoId +
                                          '?h=ff2b296e05&color=ffffff'
                                        }
                                        width='100%'
                                        height='400px'
                                        allow='autoplay; fullscreen; picture-in-picture'
                                      ></iframe>
                                    )
                                  ) : banner.BannerType !== IBannerTypeEnum.LinkYok ? (
                                    banner.Image && banner.Image.toLocaleLowerCase('tr-TR').indexOf('.mp4') > -1 ? (
                                      <video
                                        width='100%'
                                        preload='auto'
                                        autoPlay
                                        muted
                                        controls
                                        style={{ height: '100%', padding: '0px 0 0 0' }}
                                      >
                                        <source src={banner.ImageUrl} type='video/mp4'></source>
                                        Sorry, your browser doesn't support videos.
                                      </video>
                                    ) : banner.ProductAddress ? (
                                      <a
                                        className={isOutboundLink(banner.ProductAddress) ? 'outbound_link' : ''}
                                        href={banner.ProductAddress}
                                        target={banner.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
                                        rel='noreferrer'
                                        onClick={() => {
                                          if (isOutboundLink(banner.ProductAddress))
                                            handleOutBoundClicks(banner.Id, banner.Title)
                                        }}
                                      >
                                        {
                                          <Image
                                            className='banner'
                                            // style={{ height: '100%', padding: '0px 0 0 0' }}
                                            style={{
                                              height: '100%',
                                              padding: '0px 0 0 0',
                                              objectFit: 'contain',
                                              objectPosition: 'bottom',
                                              backgroundColor: '#f5f5f5',
                                            }}
                                            src={banner.ImageUrl}
                                            alt={banner.Title}
                                          />
                                        }
                                      </a>
                                    ) : (
                                      <Link
                                        to={`/products?bannerId=${banner.Id}`}
                                        target={banner.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
                                      >
                                        {
                                          <Image
                                            className='banner'
                                            // style={{ height: '100%', padding: '0px 0 0 0' }}
                                            style={{
                                              height: '100%',
                                              padding: '0px 0 0 0',
                                              objectFit: 'contain',
                                              objectPosition: 'bottom',
                                              backgroundColor: '#f5f5f5',
                                            }}
                                            src={banner.ImageUrl}
                                            alt={banner.Title}
                                          />
                                        }
                                      </Link>
                                    )
                                  ) : (
                                    <Image
                                      className='banner'
                                      // style={{ height: '100%', padding: '0px 0 0 0' }}
                                      style={{
                                        height: '100%',
                                        padding: '0px 0 0 0',
                                        objectFit: 'contain',
                                        objectPosition: 'bottom',
                                        backgroundColor: '#f5f5f5',
                                      }}
                                      src={banner.ImageUrl}
                                      alt={banner.Title}
                                    />
                                  )}
                                </SwiperSlide>
                              )
                            })}
                      </Swiper>{' '}
                    </div>
                  )}
                  {activeTab === SliderCategory.NewYear && (
                    <div
                      className='tab-pane fade active show'
                      id={SliderCategory.NewYear.toString()}
                      role='tabpanel'
                      aria-labelledby='newyear-tab'
                      style={{ height: '100%' }}
                    >
                      <Swiper
                        navigation={true}
                        keyboard={true}
                        loop={SliderLoop(state.rightBanners, ILocationEnum.AnaSayfaSag, Number(activeTab))}
                        autoplay={{
                          delay: 15000,
                          disableOnInteraction: false,
                        }}
                        pagination={{ clickable: true }}
                        observer={true}
                        observeParents={true}
                        modules={[Navigation, Mousewheel, Keyboard, Pagination, Autoplay]}
                        className='mySwiper'
                      >
                        {state.rightBanners &&
                          state.rightBanners
                            .filter((bannerItem: IBanner) => {
                              return (
                                bannerItem.Location === ILocationEnum.AnaSayfaSag &&
                                bannerItem.Category &&
                                bannerItem.Category === Number(activeTab)
                              )
                            })
                            .map((banner: IBanner, index: number) => {
                              return (
                                <SwiperSlide key={index}>
                                  {banner.BannerType === IBannerTypeEnum.YoutubeVideo ? (
                                    banner.VideoId && (
                                      <iframe
                                        width='100%'
                                        style={{ height: '400px' }}
                                        src={'https://www.youtube.com/embed/' + banner.VideoId}
                                        title='YouTube video player'
                                        frameBorder='0'
                                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                                        allowFullScreen
                                      ></iframe>
                                    )
                                  ) : banner.BannerType === IBannerTypeEnum.VimeoVideo ? (
                                    banner.VideoId && (
                                      <iframe
                                        src={
                                          'https://player.vimeo.com/video/' +
                                          banner.VideoId +
                                          '?h=ff2b296e05&color=ffffff'
                                        }
                                        width='640'
                                        height='360'
                                        allow='autoplay; fullscreen; picture-in-picture'
                                      ></iframe>
                                    )
                                  ) : banner.BannerType !== IBannerTypeEnum.LinkYok ? (
                                    banner.Image && banner.Image.toLocaleLowerCase('tr-TR').indexOf('.mp4') > -1 ? (
                                      <video
                                        width='100%'
                                        preload='auto'
                                        autoPlay
                                        muted
                                        controls
                                        style={{ height: '100%', padding: '0px 0 0 0' }}
                                      >
                                        <source src={banner.ImageUrl} type='video/mp4'></source>
                                        Sorry, your browser doesn't support videos.
                                      </video>
                                    ) : banner.ProductAddress ? (
                                      <a
                                        className={isOutboundLink(banner.ProductAddress) ? 'outbound_link' : ''}
                                        href={banner.ProductAddress}
                                        target={banner.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
                                        rel='noreferrer'
                                        onClick={() => {
                                          if (isOutboundLink(banner.ProductAddress))
                                            handleOutBoundClicks(banner.Id, banner.Title)
                                        }}
                                      >
                                        {
                                          <Image
                                            className='banner'
                                            // style={{ height: '100%', padding: '0px 0 0 0' }}
                                            style={{
                                              height: '100%',
                                              padding: '0px 0 0 0',
                                              objectFit: 'contain',
                                              objectPosition: 'bottom',
                                              backgroundColor: '#f5f5f5',
                                            }}
                                            src={banner.ImageUrl}
                                            alt={banner.Title}
                                          />
                                        }
                                      </a>
                                    ) : (
                                      <Link
                                        to={`/products?bannerId=${banner.Id}`}
                                        target={banner.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
                                      >
                                        {
                                          <Image
                                            className='banner'
                                            // style={{ height: '100%', padding: '0px 0 0 0' }}
                                            style={{
                                              height: '100%',
                                              padding: '0px 0 0 0',
                                              objectFit: 'contain',
                                              objectPosition: 'bottom',
                                              backgroundColor: '#f5f5f5',
                                            }}
                                            src={banner.ImageUrl}
                                            alt={banner.Title}
                                          />
                                        }
                                      </Link>
                                    )
                                  ) : (
                                    <Image
                                      className='banner'
                                      // style={{ height: '100%', padding: '0px 0 0 0' }}
                                      style={{
                                        height: '100%',
                                        padding: '0px 0 0 0',
                                        objectFit: 'contain',
                                        objectPosition: 'bottom',
                                        backgroundColor: '#f5f5f5',
                                      }}
                                      src={banner.ImageUrl}
                                      alt={banner.Title}
                                    />
                                  )}
                                </SwiperSlide>
                              )
                            })}
                      </Swiper>
                    </div>
                  )}
                  {activeTab === SliderCategory.Privileges && (
                    <div
                      className='tab-pane fade active show'
                      id={SliderCategory.Privileges.toString()}
                      role='tabpanel'
                      aria-labelledby='privileges-tab'
                      style={{ height: '100%' }}
                    >
                      <Swiper
                        navigation={true}
                        keyboard={true}
                        loop={SliderLoop(state.rightBanners, ILocationEnum.AnaSayfaSag, Number(activeTab))}
                        autoplay={{
                          delay: 15000,
                          disableOnInteraction: false,
                        }}
                        pagination={{ clickable: true }}
                        observer={true}
                        observeParents={true}
                        modules={[Navigation, Mousewheel, Keyboard, Pagination, Autoplay]}
                        className='mySwiper'
                      >
                        {state.rightBanners &&
                          state.rightBanners
                            .filter((bannerItem: IBanner) => {
                              return (
                                bannerItem.Location === ILocationEnum.AnaSayfaSag &&
                                bannerItem.Category &&
                                bannerItem.Category === Number(activeTab)
                              )
                            })
                            .map((banner: IBanner, index: number) => {
                              return (
                                <SwiperSlide key={index}>
                                  {banner.BannerType === IBannerTypeEnum.YoutubeVideo ? (
                                    banner.VideoId && (
                                      <iframe
                                        width='100%'
                                        style={{ height: '400px' }}
                                        src={'https://www.youtube.com/embed/' + banner.VideoId}
                                        title='YouTube video player'
                                        frameBorder='0'
                                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                                        allowFullScreen
                                      ></iframe>
                                    )
                                  ) : banner.BannerType === IBannerTypeEnum.VimeoVideo ? (
                                    banner.VideoId && (
                                      <iframe
                                        src={
                                          'https://player.vimeo.com/video/' +
                                          banner.VideoId +
                                          '?h=ff2b296e05&color=ffffff'
                                        }
                                        width='640'
                                        height='360'
                                        allow='autoplay; fullscreen; picture-in-picture'
                                      ></iframe>
                                    )
                                  ) : banner.BannerType !== IBannerTypeEnum.LinkYok ? (
                                    banner.Image && banner.Image.toLocaleLowerCase('tr-TR').indexOf('.mp4') > -1 ? (
                                      <video
                                        width='100%'
                                        preload='auto'
                                        autoPlay
                                        muted
                                        controls
                                        style={{ height: '100%', padding: '0px 0 0 0' }}
                                      >
                                        <source src={banner.ImageUrl} type='video/mp4'></source>
                                        Sorry, your browser doesn't support videos.
                                      </video>
                                    ) : banner.ProductAddress ? (
                                      <a
                                        className={isOutboundLink(banner.ProductAddress) ? 'outbound_link' : ''}
                                        href={banner.ProductAddress}
                                        target={banner.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
                                        rel='noreferrer'
                                        onClick={() => {
                                          if (isOutboundLink(banner.ProductAddress))
                                            handleOutBoundClicks(banner.Id, banner.Title)
                                        }}
                                      >
                                        {
                                          <Image
                                            className='banner'
                                            // style={{ height: '100%', padding: '0px 0 0 0' }}
                                            style={{
                                              height: '100%',
                                              padding: '0px 0 0 0',
                                              objectFit: 'contain',
                                              objectPosition: 'bottom',
                                              backgroundColor: '#f5f5f5',
                                            }}
                                            src={banner.ImageUrl}
                                            alt={banner.Title}
                                          />
                                        }
                                      </a>
                                    ) : (
                                      <Link
                                        to={`/products?bannerId=${banner.Id}`}
                                        target={banner.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
                                      >
                                        {
                                          <Image
                                            className='banner'
                                            // style={{ height: '100%', padding: '0px 0 0 0' }}
                                            style={{
                                              height: '100%',
                                              padding: '0px 0 0 0',
                                              objectFit: 'contain',
                                              objectPosition: 'bottom',
                                              backgroundColor: '#f5f5f5',
                                            }}
                                            src={banner.ImageUrl}
                                            alt={banner.Title}
                                          />
                                        }
                                      </Link>
                                    )
                                  ) : (
                                    <Image
                                      className='banner'
                                      // style={{ height: '100%', padding: '0px 0 0 0' }}
                                      style={{
                                        height: '100%',
                                        padding: '0px 0 0 0',
                                        objectFit: 'contain',
                                        objectPosition: 'bottom',
                                        backgroundColor: '#f5f5f5',
                                      }}
                                      src={banner.ImageUrl}
                                      alt={banner.Title}
                                    />
                                  )}
                                </SwiperSlide>
                              )
                            })}
                      </Swiper>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        {state.sliderStopwatchesOnBottom && state.sliderStopwatchesOnBottom.length > 0 && (
          <div className='row mb-4 p-t-20'>
            <div className='col-12'>
              <Swiper
                navigation={true}
                keyboard={true}
                loop={state.sliderStopwatchesOnBottom.length === 1 ? false : true}
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
                }}
                pagination={{ clickable: true }}
                observer={true}
                observeParents={true}
                modules={[Navigation, Mousewheel, Keyboard, Pagination, Autoplay]}
                className='mySwiper'
              >
                {state.sliderStopwatchesOnBottom.map((stopWatch: IBanner, index: number) => {
                  return (
                    <SwiperSlide key={stopWatch.Id}>
                      {stopWatch.BannerType !== IBannerTypeEnum.LinkYok ? (
                        stopWatch.ProductAddress ? (
                          <a
                            href={stopWatch.ProductAddress}
                            target={stopWatch.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
                            rel='noreferrer'
                            onClick={() => {
                              if (isOutboundLink(stopWatch.ProductAddress))
                                handleOutBoundClicks(stopWatch.Id, stopWatch.Title)
                            }}
                          >
                            {renderStopwatchWithCompanyLogo(stopWatch)}
                          </a>
                        ) : (
                          <Link
                            to={`/products?bannerId=${stopWatch.Id}`}
                            target={stopWatch.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
                          >
                            {renderStopwatchWithCompanyLogo(stopWatch)}
                          </Link>
                        )
                      ) : (
                        renderStopwatchWithCompanyLogo(stopWatch)
                      )}
                    </SwiperSlide>
                  )
                })}
              </Swiper>
            </div>
          </div>
        )}
        {state.oneAfterTheOtherStopwatchesOnBottom &&
          state.oneAfterTheOtherStopwatchesOnBottom.map((stopWatch: IBanner) => {
            return (
              <div className='mb-4 mt-4' key={stopWatch.Id}>
                {stopWatch.BannerType !== IBannerTypeEnum.LinkYok ? (
                  <a
                    href={stopWatch.ProductAddress ? stopWatch.ProductAddress : `/products?bannerId=${stopWatch.Id}`}
                    target={stopWatch.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
                    rel='noreferrer'
                    onClick={() => {
                      if (isOutboundLink(stopWatch.ProductAddress)) handleOutBoundClicks(stopWatch.Id, stopWatch.Title)
                    }}
                  >
                    {renderStopwatchWithCompanyLogo(stopWatch)}
                  </a>
                ) : (
                  renderStopwatchWithCompanyLogo(stopWatch)
                )}
              </div>
            )
          })}
        {state.specialForMe && state.specialForMe.BannerType !== IBannerTypeEnum.LinkYok ? (
          state.specialForMe.ProductAddress ? (
            <a
              href={state.specialForMe.ProductAddress}
              target={state.specialForMe.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
              rel='noreferrer'
            >
              <div
                className='homeSpecialBanner text-light text-center m-b-0 m-t-20 p-t-50 p-b-50 '
                style={{
                  backgroundImage: state.specialForMe.ImageUrl,
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              ></div>
            </a>
          ) : (
            <Link
              to={`/products?bannerId=${state.specialForMe.Id}`}
              target={state.specialForMe.BannerType === IBannerTypeEnum.YeniPencereLink ? '_blank' : ''}
            >
              <div
                className='homeSpecialBanner text-light text-center m-b-0 m-t-20 p-t-50 p-b-50 '
                style={{
                  backgroundImage: state.specialForMe.ImageUrl,
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              ></div>
            </Link>
          )
        ) : (
          state.specialForMe && (
            <div
              className='homeSpecialBanner text-light text-center m-b-0 m-t-20 p-t-50 p-b-50 '
              style={{
                backgroundImage: state.specialForMe.ImageUrl,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            ></div>
          )
        )}
      </div>
      <ProductIQuotaForm ref={iQuotaFormRef} />
    </section>
  )
}
export default HomePageSlider


